"use client";

import { useEffect } from "react";

const SAMPLE_INTERVAL_MS = 60_000;
const PEAK_WINDOW_MS = 1_000;

declare global {
  interface Window {
    __reactCommitTimes?: number[];
  }
}

function peakCommitsPerSecond(times: number[]): number {
  if (times.length === 0) {
    return 0;
  }
  let peak = 1;
  let lo = 0;
  for (let hi = 1; hi < times.length; hi++) {
    while (times[hi]! - times[lo]! >= PEAK_WINDOW_MS) {
      lo++;
    }
    const depth = hi - lo + 1;
    if (depth > peak) {
      peak = depth;
    }
  }
  return peak;
}

export function ReactCommitTracker() {
  useEffect(() => {
    const interval = setInterval(async () => {
      const commits = window.__reactCommitTimes;
      if (commits == null || commits.length === 0) {
        return;
      }
      const snapshot = commits.splice(0);
      const peak = peakCommitsPerSecond(snapshot);
      const { datadogRum } = await import("@datadog/browser-rum-slim");
      datadogRum.addAction("react.commit_stats", {
        peak_depth: peak,
        total_commits: snapshot.length,
      });
    }, SAMPLE_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);
  return null;
}
